module.exports = __webpack_public_path__ + "img/overblog.png";